import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { FaBell } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { AdminProfileAPI } from "../../API/auth/SigninAction";
import {
  getNotifications,
  readAllNotifications,
} from "../../API/NotificationApi/NotificationApi";
import Loader from "../Loader/Loader";
import DummyImage from "../image/DummyImage";

const NotificationDropdown = ({ show, notifications, loading, onClose }) => {
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        onClose();
      }
    };

    if (show) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [show, onClose]);

  if (!show) return null;

  return ReactDOM.createPortal(
    <div
      className="absolute top-16 right-2 sm:right-32 w-64 bg-white shadow-lg rounded-md overflow-hidden z-50"
      ref={dropdownRef}
    >
      <div className="p-2">
        <h2 className="text-lg font-semibold">Notifications</h2>
        <ul className="h-[200px] overflow-y-scroll">
          {loading ? (
            <div className="flex items-center justify-center">
              <Loader />
            </div>
          ) : notifications.length > 0 ? (
            notifications.map((item, index) => (
              <li
                key={index}
                className={`py-2 px-2 border-b border-gray-200 flex items-center space-x-2 ${
                  item.isRead ? "bg-gray-100" : "bg-blue-50"
                }`}
              >
                <div>
                  <p className="text-sm text-gray-600">{item.message}</p>
                </div>
                <span className="ml-auto text-xs text-gray-400">
                  {new Date(item.createdAt).toLocaleString()}
                </span>
              </li>
            ))
          ) : (
            <div className="text-center text-gray-500 py-4">
              No notifications yet
            </div>
          )}
        </ul>
      </div>
    </div>,
    document.body // Mounts the dropdown to the `body` element
  );
};

const Header = () => {
  const dispatch = useDispatch();
  const { AdminProfile } = useSelector((state) => state?.adminProfile);
  const [showNotifications, setShowNotifications] = useState(false);
  const [Notifications, setNotifications] = useState([]);
  const [notificationloading, setNotificationloading] = useState(false);

  const handleBellClick = async () => {
    setShowNotifications(!showNotifications);
    if (!showNotifications) {
      await fetchNotifications();
    }
  };

  const fetchNotifications = async () => {
    try {
      setNotificationloading(true);
      const notifications = await getNotifications();
      setNotifications(notifications);
      setNotificationloading(false);
      await readAllNotifications();
    } catch (err) {
      setNotificationloading(false);
      console.error(err);
    }
  };

  useEffect(() => {
    dispatch(AdminProfileAPI());
  }, [dispatch]);

  return (
    <div className="flex justify-between items-center h-14 px-1 sm:px-8 break-all overflow-hidden">
      <h1 className="text-[8px] sm:text-xl font-semibold">
        Hi, {AdminProfile?.first_name} {AdminProfile?.last_name}
      </h1>
      <div className="flex sm:flex-row items-center gap-7">
        <div className="relative">
          <FaBell
            className="text-2xl text-gray-400 cursor-pointer"
            onClick={handleBellClick}
          />
        </div>
        <div className="flex items-center space-x-3">
          {AdminProfile?.profileImage ? (
            <img
              src={AdminProfile?.profileImage}
              alt={AdminProfile?.first_name}
              className="w-10 h-10 rounded-full object-cover object-center aspect-auto"
            />
          ) : (
            <DummyImage customClass="w-10 h-10" />
          )}
          <div>
            <h1 className="text-[8px] sm:text-sm font-semibold text-gray-700">
              {AdminProfile?.first_name}
            </h1>
            <p className="text-[8px] sm:text-xs text-gray-500">
              {AdminProfile?.email}
            </p>
          </div>
        </div>
      </div>
      <NotificationDropdown
        show={showNotifications}
        notifications={Notifications}
        loading={notificationloading}
        onClose={() => setShowNotifications(false)}
      />
    </div>
  );
};

export default Header;
